<template>
  <div
    class="sections-menu p-md-3"
  >
    <div
      v-for="(page, index) in pages"
      :key="index"

      :title="page.caption"
      class="d-flex justify-content-end p-1"
      :class="{active: selection == index}"
      @mouseenter="selectionHover = index"
      @touchstart="selectionHover = index"
      @mouseleave="selectionHover = -1"
      @touchmove="selectionHover = index"
      @click="clickElement(index)"
    >
      <transition name="menu-caption-transition">
        <div
          v-show="selectionHover === index"
          class="align-self-center rounded px-2
           focused menu-caption text-secondary font-weight-bold"
        >
          {{ page.caption }}
        </div>
      </transition>
      <div
        class="menu-point"
      />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    selection: {
      type: Number,
      required: true,
    },
    pages: { type: Array, required: true },
  },
  data() {
    return {
      selectionHover: -1,
    };
  },
  methods: {
    clickElement(index) {
      // clear hover (display of text)
      setTimeout(() => { this.selectionHover = -1; }, 500);
      // communicate with parent component to change the current page
      this.$emit('scrollTo', index);
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-point {
 border: 0.2em solid map-get($theme-colors, secondary);
  width: 1.2em;
  height: 1.2em;
  margin: 0.5em 0;
  opacity: .6;
  border-radius: 50%;
  transition: all .4s ease;
  cursor: pointer;
}
.active .menu-point {
   background-color:map-get($theme-colors, secondary);

}
.focused {
  background-color: rgba(lighten(map-get($theme-colors, primary), 30%), 1);
}
</style>

<style scoped>
.sections-menu {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  min-width: 3em;
}
.active .menu-point {
  opacity: 1;
  transform: scale(1.5);
}
.active .menu-caption {
  margin-right: 0.75em;
}
.menu-caption {
  transition: all .4s ease;
  margin-right: 0.25em;
  text-transform: capitalize;
  cursor: pointer;
}

.menu-caption-transition-enter-active, .menu-caption-transition-leave-active {
  transition: all .3s ease;
}

.menu-caption-transition-enter, .menu-caption-transition-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(5px);
  opacity: 0;
}

</style>
